import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ToggleService } from '../../shared/toggle-service/toggle.service';
import { environment } from '../../../environments/environment';
import * as build from '../../../../build-version.json';

@Component({
  standalone: false,
  selector: 'app-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.css'],
})
export class SideBarComponent implements OnInit {
  server_environment: string;
  server_version: string;
  currentYear: number;
  isAdmin: boolean;

  constructor(
    readonly toggleService: ToggleService,
    readonly location: Location,
  ) {
    this.server_environment = window.location.host.split(/[.]/)[0].split(/[-]/)[0].split(':')[0];
    this.server_version = 'AutomapAI version: ' + environment.version + '\nBuild version: ';

    try {
      this.server_version += build?.buildVersion;
    } catch (e) {
      console.warn(e);
    }
    //**keep this console.log in the source code to display the build version in the browser console
    console.log(this.server_version);
  }

  ngOnInit(): void {
    this.currentYear = new Date().getFullYear();
    setTimeout(() => {
      this.isAdmin = JSON.parse(localStorage.getItem('user_data_automap'))?.role?.toLowerCase() == 'admin';
    }, 1000);
  }

  navigateToTH() {
    window.location.href = 'https://www.terminologyhub.com/automap';
  }
}
